import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
 
const ApprovalDashboard = ({ approvalData,approvalResponseData, selectedPolygon, setSelectedPolygon }) => {
  const [selectedArea, setSelectedArea] = useState("All");

  // Dummy grouped approval (until backend provides)
  const approvalByAge = [
    { age: "18-29", approval: 60 },
    { age: "30-44", approval: 65 },
    { age: "45-59", approval: 68 },
    { age: "60+", approval: 71 },
  ];

  const approvalByGender = [
    { gender: "Male", approval: 66 },
    { gender: "Female", approval: 70 },
    { gender: "Other", approval: 58 },
  ];

const handleAreaChange = (e) => {
  const area = e.target.value;
  setSelectedArea(area);

  if (area === "All") {
    setSelectedPolygon(null); // reset selection
    return;
  }

  // Find matching polygon from rendered polygonPaths instead of raw response
  const matchedPolygon = approvalResponseData.find((item) => item.name === area);
  
  if (matchedPolygon) {
    // Build polygon object with coordinates like in map
    let coordinates = [];
    if (matchedPolygon.boundaries?.type === "MultiPolygon") {
      matchedPolygon.boundaries.coordinates.forEach((poly) => {
        const coords = poly[0]
          .map(([lng, lat]) => ({ lat: Number(lat), lng: Number(lng) }))
          .filter(Boolean);
        coordinates = coords;
      });
    }
    setSelectedPolygon({
      ...matchedPolygon,
      coordinate: coordinates,
    });
  } else {
    setSelectedPolygon(null);
  }
};


  return (
    <div className="absolute top-15 right-4 bg-white/20 backdrop-blur-[30px] border border-white/40 rounded-3xl p-4 shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] w-[420px] max-h-[90vh] overflow-y-auto z-[9]">
      <h2 className="text-2xl font-bold text-center text-[#004877] mb-3">
        Approval Rating Dashboard
      </h2>
      <p className="text-center font-bold text-black/90 mb-3">
        Are you satisfied with the current government? 
      </p>
      <h1 className="text-center text-4xl font-extrabold text-[#2E7D32] mb-3">
        64%
      </h1>

      {/* Dropdown */}
      <select
        className="w-full mb-3 rounded-xl bg-black/10 text-black px-2 py-1 outline-none"
        value={selectedArea}
        onChange={handleAreaChange}
      >
        <option className="text-black/60" value="All">All Areas</option>
        {approvalResponseData.map((item, idx) => (
          <option key={idx} className="text-black" value={item.name}>
            {item.name}
          </option>
        ))}
      </select>

      {/* Approval % by Area */}
      <div className="mb-4">
        <h3 className="text-md text-black/70 font-bold mb-1">Approval % by Area</h3>

       <ResponsiveContainer width="100%" height={180}>
            <BarChart data={approvalData}>
                <XAxis
                dataKey="area"
                stroke="#000"
                tick={{
                    angle: -40,
                    textAnchor: "end",
                    fontSize: 11,
                    fill: "#333",
                }}
                interval={0}
                height={70}
                />
                <YAxis domain={[0, 100]} stroke="#000" />

                <Tooltip
                content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                    return (
                        <div className="bg-white px-3 py-2 shadow-md rounded-md border border-gray-200">
                        <p className="font-semibold text-gray-800">{label}</p>
                        <p className="text-sm text-gray-600">
                            Approval: <span className="font-bold">{payload[0].value}%</span>
                        </p>
                        </div>
                    );
                    }
                    return null;
                }}
                />
                <Bar
                dataKey="approval"
                onClick={(data) => {
                  // Trigger dropdown + polygon update
                  handleAreaChange({ target: { value: data.area } });
                }}
              >
                {approvalData.map((entry, idx) => (
                  <Cell
                    key={`cell-${idx}`}
                    fill={selectedArea === entry.area ? "#4682B4" : "#004877"} 
                    cursor="pointer"
                  />
                ))}
              </Bar>
            </BarChart>
        </ResponsiveContainer>

      </div>

<div className="mb-6">
  <div className="grid grid-cols-2 gap-4">
    {/* Age Group */}
    <div>
      <h3 className="text-md text-black/70 font-bold mb-1">
        Approval % by Age Group
      </h3>
      <ResponsiveContainer width="100%" height={150}>
        <BarChart data={approvalByAge}>
          <XAxis 
            dataKey="age" 
            stroke="#000" 
            interval={0}
            tick={{
                angle: -40,
                textAnchor: "end",
                fontSize: 11,
                fill: "#333",
            }}/>
          <YAxis domain={[0, 100]} stroke="#000" />
          {/* <Tooltip /> */}
           <Tooltip
            content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                return (
                    <div className="bg-white px-3 py-2 shadow-md rounded-md border border-gray-200">
                    <p className="font-semibold text-gray-800">{label}</p>
                    <p className="text-sm text-gray-600">
                        Approval: <span className="font-bold">{payload[0].value}%</span>
                    </p>
                    </div>
                );
                }
                return null;
            }}
            />
          <Bar dataKey="approval" fill="#004877" />
        </BarChart>
      </ResponsiveContainer>
    </div>

    {/* Gender */}
    <div>
      <h3 className="text-md text-black/70 font-bold mb-1">
        Approval % by Gender
      </h3>
      <ResponsiveContainer width="100%" height={150}>
        <BarChart data={approvalByGender}>
          <XAxis dataKey="gender" stroke="#000" />
          <YAxis domain={[0, 100]} stroke="#000" />
          <Tooltip
            content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                return (
                    <div className="bg-white px-3 py-2 shadow-md rounded-md border border-gray-200">
                    <p className="font-semibold text-gray-800">{label}</p>
                    <p className="text-sm text-gray-600">
                        Approval: <span className="font-bold">{payload[0].value}%</span>
                    </p>
                    </div>
                );
                }
                return null;
            }}
            />
          <Bar dataKey="approval" fill="#004877" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
</div>
    </div>
  );
}

export default ApprovalDashboard;
